/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type {
  GetQuizSetSitemapEntriesByCountryCodeParams,
  GetQuizsetSummaryParams,
  GetQuizsetTitleParams,
  GetTopPlayedQuizsetsParams,
  SuccessBody,
  SuccessBodyListQuizsetPlayCountResult,
  SuccessBodyListString,
  SuccessBodyQuizSetIdsRes,
  SuccessBodyQuizsetSummaryDto,
  SuccessBodySeoSitemapPageSitemapEntry,
  SuccessBodyString,
  UpdatePlayCountParams,
} from '.././_model';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const updatePlayCount = (
  params: UpdatePlayCountParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBody>(
    { url: `/quizsets/play-count`, method: 'POST', params, signal },
    options,
  );
};

export const getUpdatePlayCountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlayCount>>,
    TError,
    { params: UpdatePlayCountParams },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePlayCount>>,
  TError,
  { params: UpdatePlayCountParams },
  TContext
> => {
  const mutationKey = ['updatePlayCount'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePlayCount>>,
    { params: UpdatePlayCountParams }
  > = props => {
    const { params } = props ?? {};

    return updatePlayCount(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePlayCountMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePlayCount>>
>;

export type UpdatePlayCountMutationError = ErrorType<unknown>;

export const useUpdatePlayCount = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePlayCount>>,
      TError,
      { params: UpdatePlayCountParams },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePlayCount>>,
  TError,
  { params: UpdatePlayCountParams },
  TContext
> => {
  const mutationOptions = getUpdatePlayCountMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getTopPlayedQuizsets = (
  params: GetTopPlayedQuizsetsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListQuizsetPlayCountResult>(
    { url: `/quizsets/top-play-counts`, method: 'GET', params, signal },
    options,
  );
};

export const getGetTopPlayedQuizsetsQueryKey = (
  params: GetTopPlayedQuizsetsParams,
) => {
  return [`/quizsets/top-play-counts`, ...(params ? [params] : [])] as const;
};

export const getGetTopPlayedQuizsetsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
  TError = ErrorType<unknown>,
>(
  params: GetTopPlayedQuizsetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopPlayedQuizsetsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopPlayedQuizsets>>
  > = ({ signal }) => getTopPlayedQuizsets(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopPlayedQuizsetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopPlayedQuizsets>>
>;
export type GetTopPlayedQuizsetsQueryError = ErrorType<unknown>;

export function useGetTopPlayedQuizsets<
  TData = Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
  TError = ErrorType<unknown>,
>(
  params: GetTopPlayedQuizsetsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
          TError,
          Awaited<ReturnType<typeof getTopPlayedQuizsets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopPlayedQuizsets<
  TData = Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
  TError = ErrorType<unknown>,
>(
  params: GetTopPlayedQuizsetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
          TError,
          Awaited<ReturnType<typeof getTopPlayedQuizsets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopPlayedQuizsets<
  TData = Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
  TError = ErrorType<unknown>,
>(
  params: GetTopPlayedQuizsetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopPlayedQuizsets<
  TData = Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
  TError = ErrorType<unknown>,
>(
  params: GetTopPlayedQuizsetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopPlayedQuizsetsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetTopPlayedQuizsetsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
  TError = ErrorType<unknown>,
>(
  params: GetTopPlayedQuizsetsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopPlayedQuizsetsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopPlayedQuizsets>>
  > = ({ signal }) => getTopPlayedQuizsets(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopPlayedQuizsetsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopPlayedQuizsets>>
>;
export type GetTopPlayedQuizsetsSuspenseQueryError = ErrorType<unknown>;

export function useGetTopPlayedQuizsetsSuspense<
  TData = Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
  TError = ErrorType<unknown>,
>(
  params: GetTopPlayedQuizsetsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopPlayedQuizsetsSuspense<
  TData = Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
  TError = ErrorType<unknown>,
>(
  params: GetTopPlayedQuizsetsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopPlayedQuizsetsSuspense<
  TData = Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
  TError = ErrorType<unknown>,
>(
  params: GetTopPlayedQuizsetsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetTopPlayedQuizsetsSuspense<
  TData = Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
  TError = ErrorType<unknown>,
>(
  params: GetTopPlayedQuizsetsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getTopPlayedQuizsets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetTopPlayedQuizsetsSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getQuizsetTitle = (
  params: GetQuizsetTitleParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyString>(
    { url: `/quizsets/title`, method: 'GET', params, signal },
    options,
  );
};

export const getGetQuizsetTitleQueryKey = (params: GetQuizsetTitleParams) => {
  return [`/quizsets/title`, ...(params ? [params] : [])] as const;
};

export const getGetQuizsetTitleQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizsetTitle>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetTitleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetTitle>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuizsetTitleQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuizsetTitle>>> = ({
    signal,
  }) => getQuizsetTitle(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizsetTitle>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizsetTitleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizsetTitle>>
>;
export type GetQuizsetTitleQueryError = ErrorType<unknown>;

export function useGetQuizsetTitle<
  TData = Awaited<ReturnType<typeof getQuizsetTitle>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetTitleParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetTitle>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizsetTitle>>,
          TError,
          Awaited<ReturnType<typeof getQuizsetTitle>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizsetTitle<
  TData = Awaited<ReturnType<typeof getQuizsetTitle>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetTitleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetTitle>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizsetTitle>>,
          TError,
          Awaited<ReturnType<typeof getQuizsetTitle>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuizsetTitle<
  TData = Awaited<ReturnType<typeof getQuizsetTitle>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetTitleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetTitle>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetQuizsetTitle<
  TData = Awaited<ReturnType<typeof getQuizsetTitle>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetTitleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetTitle>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuizsetTitleQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetQuizsetTitleSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizsetTitle>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetTitleParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetTitle>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuizsetTitleQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuizsetTitle>>> = ({
    signal,
  }) => getQuizsetTitle(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizsetTitle>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizsetTitleSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizsetTitle>>
>;
export type GetQuizsetTitleSuspenseQueryError = ErrorType<unknown>;

export function useGetQuizsetTitleSuspense<
  TData = Awaited<ReturnType<typeof getQuizsetTitle>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetTitleParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetTitle>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizsetTitleSuspense<
  TData = Awaited<ReturnType<typeof getQuizsetTitle>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetTitleParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetTitle>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizsetTitleSuspense<
  TData = Awaited<ReturnType<typeof getQuizsetTitle>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetTitleParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetTitle>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetQuizsetTitleSuspense<
  TData = Awaited<ReturnType<typeof getQuizsetTitle>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetTitleParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetTitle>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetQuizsetTitleSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getQuizsetSummary = (
  params: GetQuizsetSummaryParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetSummaryDto>(
    { url: `/quizsets/summary`, method: 'GET', params, signal },
    options,
  );
};

export const getGetQuizsetSummaryQueryKey = (
  params: GetQuizsetSummaryParams,
) => {
  return [`/quizsets/summary`, ...(params ? [params] : [])] as const;
};

export const getGetQuizsetSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizsetSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizsetSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizsetSummary>>
  > = ({ signal }) => getQuizsetSummary(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizsetSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizsetSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizsetSummary>>
>;
export type GetQuizsetSummaryQueryError = ErrorType<unknown>;

export function useGetQuizsetSummary<
  TData = Awaited<ReturnType<typeof getQuizsetSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizsetSummary>>,
          TError,
          Awaited<ReturnType<typeof getQuizsetSummary>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizsetSummary<
  TData = Awaited<ReturnType<typeof getQuizsetSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizsetSummary>>,
          TError,
          Awaited<ReturnType<typeof getQuizsetSummary>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuizsetSummary<
  TData = Awaited<ReturnType<typeof getQuizsetSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetQuizsetSummary<
  TData = Awaited<ReturnType<typeof getQuizsetSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuizsetSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetQuizsetSummarySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizsetSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizsetSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizsetSummary>>
  > = ({ signal }) => getQuizsetSummary(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizsetSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizsetSummarySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizsetSummary>>
>;
export type GetQuizsetSummarySuspenseQueryError = ErrorType<unknown>;

export function useGetQuizsetSummarySuspense<
  TData = Awaited<ReturnType<typeof getQuizsetSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetSummaryParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizsetSummarySuspense<
  TData = Awaited<ReturnType<typeof getQuizsetSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizsetSummarySuspense<
  TData = Awaited<ReturnType<typeof getQuizsetSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetQuizsetSummarySuspense<
  TData = Awaited<ReturnType<typeof getQuizsetSummary>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetQuizsetSummarySuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getQuizSetSitemapEntriesByCountryCode = (
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodySeoSitemapPageSitemapEntry>(
    { url: `/quizsets/sitemap-entries`, method: 'GET', params, signal },
    options,
  );
};

export const getGetQuizSetSitemapEntriesByCountryCodeQueryKey = (
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
) => {
  return [`/quizsets/sitemap-entries`, ...(params ? [params] : [])] as const;
};

export const getGetQuizSetSitemapEntriesByCountryCodeQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetQuizSetSitemapEntriesByCountryCodeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>
  > = ({ signal }) =>
    getQuizSetSitemapEntriesByCountryCode(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizSetSitemapEntriesByCountryCodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>
>;
export type GetQuizSetSitemapEntriesByCountryCodeQueryError =
  ErrorType<unknown>;

export function useGetQuizSetSitemapEntriesByCountryCode<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
          TError,
          Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizSetSitemapEntriesByCountryCode<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
          TError,
          Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuizSetSitemapEntriesByCountryCode<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetQuizSetSitemapEntriesByCountryCode<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuizSetSitemapEntriesByCountryCodeQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetQuizSetSitemapEntriesByCountryCodeSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetQuizSetSitemapEntriesByCountryCodeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>
  > = ({ signal }) =>
    getQuizSetSitemapEntriesByCountryCode(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizSetSitemapEntriesByCountryCodeSuspenseQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>
  >;
export type GetQuizSetSitemapEntriesByCountryCodeSuspenseQueryError =
  ErrorType<unknown>;

export function useGetQuizSetSitemapEntriesByCountryCodeSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizSetSitemapEntriesByCountryCodeSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizSetSitemapEntriesByCountryCodeSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetQuizSetSitemapEntriesByCountryCodeSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizSetSitemapEntriesByCountryCodeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapEntriesByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions =
    getGetQuizSetSitemapEntriesByCountryCodeSuspenseQueryOptions(
      params,
      options,
    );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getQuizSetSitemapCountries = (
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListString>(
    { url: `/quizsets/sitemap-countries`, method: 'GET', signal },
    options,
  );
};

export const getGetQuizSetSitemapCountriesQueryKey = () => {
  return [`/quizsets/sitemap-countries`] as const;
};

export const getGetQuizSetSitemapCountriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizSetSitemapCountriesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizSetSitemapCountries>>
  > = ({ signal }) => getQuizSetSitemapCountries(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizSetSitemapCountriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizSetSitemapCountries>>
>;
export type GetQuizSetSitemapCountriesQueryError = ErrorType<unknown>;

export function useGetQuizSetSitemapCountries<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
          TError,
          Awaited<ReturnType<typeof getQuizSetSitemapCountries>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizSetSitemapCountries<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
          TError,
          Awaited<ReturnType<typeof getQuizSetSitemapCountries>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuizSetSitemapCountries<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetQuizSetSitemapCountries<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuizSetSitemapCountriesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetQuizSetSitemapCountriesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizSetSitemapCountriesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizSetSitemapCountries>>
  > = ({ signal }) => getQuizSetSitemapCountries(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizSetSitemapCountriesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizSetSitemapCountries>>
>;
export type GetQuizSetSitemapCountriesSuspenseQueryError = ErrorType<unknown>;

export function useGetQuizSetSitemapCountriesSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizSetSitemapCountriesSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizSetSitemapCountriesSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetQuizSetSitemapCountriesSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions =
    getGetQuizSetSitemapCountriesSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getQuizSetIds = (
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizSetIdsRes>(
    { url: `/quizsets/ids`, method: 'GET', signal },
    options,
  );
};

export const getGetQuizSetIdsQueryKey = () => {
  return [`/quizsets/ids`] as const;
};

export const getGetQuizSetIdsQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizSetIds>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getQuizSetIds>>, TError, TData>
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuizSetIdsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuizSetIds>>> = ({
    signal,
  }) => getQuizSetIds(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizSetIds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizSetIdsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizSetIds>>
>;
export type GetQuizSetIdsQueryError = ErrorType<unknown>;

export function useGetQuizSetIds<
  TData = Awaited<ReturnType<typeof getQuizSetIds>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getQuizSetIds>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizSetIds>>,
          TError,
          Awaited<ReturnType<typeof getQuizSetIds>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizSetIds<
  TData = Awaited<ReturnType<typeof getQuizSetIds>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getQuizSetIds>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizSetIds>>,
          TError,
          Awaited<ReturnType<typeof getQuizSetIds>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuizSetIds<
  TData = Awaited<ReturnType<typeof getQuizSetIds>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getQuizSetIds>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetQuizSetIds<
  TData = Awaited<ReturnType<typeof getQuizSetIds>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getQuizSetIds>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuizSetIdsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetQuizSetIdsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizSetIds>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getQuizSetIds>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuizSetIdsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuizSetIds>>> = ({
    signal,
  }) => getQuizSetIds(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizSetIds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizSetIdsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizSetIds>>
>;
export type GetQuizSetIdsSuspenseQueryError = ErrorType<unknown>;

export function useGetQuizSetIdsSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetIds>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizSetIdsSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetIds>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizSetIdsSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetIds>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetQuizSetIdsSuspense<
  TData = Awaited<ReturnType<typeof getQuizSetIds>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizSetIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetQuizSetIdsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
